import React, { useState, useEffect, useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Box, Grid, Modal, IconButton, Button, ClickAwayListener, TextField, InputAdornment, Typography } from '@mui/material';
import './chat-options.css'

import {
  getInProgressRooms,
  finishRoom,
  UpdateInProgressRooms,
  selectCurrentRoom,
  setViewedRooms
} from '../../redux/room/room.actions';
import { setCurrentClient, updateClient } from '../../redux/client/client.actions';

import Closechat from '../../assets/closechat.png'
import Invitechat from '../../assets/invitechat.png'
import RightSideBar from '../../template/RightSideBar';
import ClientInformation from '../Client/ClientInformation';
import { ThemeContext } from '../ThemeContext/ThemeContext';
import { toast } from 'react-toastify';
import { setCompany } from '../../redux/company/company.actions';
import {
  AddCardSharp, MoreVert,
  ArrowBackIosRounded, Close, VpnKeySharp, CachedSharp, SwapHorizSharp, ExitToAppSharp
} from '@mui/icons-material';
import UserTransferModal from '../UserTransferModal';
import { useWebSocket } from '../WebSocketContext/WebSocketContext';
import http from '../../services/http';
// A mensagem configurada é a do DEPARTAMENTO DA SALA. Aqui a tela pegava a
// primeira da lista (`textConfigs[0]`), que é a lista inteira do tenant -- com
// mais de um departamento configurado, metade das conversas mandava o texto do
// outro. A regra vive num util testável porque ela não depende de React.
import { mensagemDeBoasVindas, mensagemDeEncerramento, tipoDoEncerramento } from '../../utils/mensagemDoDepartamento';
import ConsultaDeCadastro from '../ConsultaDeCadastro';

const ChatOptions = props => {
  const [popover, setPopover] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [clientCode, setClientCode] = useState();
  const [showCodeInput, setShowCodeInput] = useState(false);
  /*
   * A identificacao EM CONSULTA (ponto 15 da Gisele).
   *
   * Antes, o Enter nesta caixa associava na hora: um digito trocado ligava
   * a conversa a empresa errada, e o operador descobria pelo nome errado na
   * ficha -- ou nunca. Agora o Enter consulta, e o vinculo so acontece no
   * botao da janela, com a razao social e o CNPJ na frente de quem decide.
   *
   * Guarda a identificacao, e nao um booleano: e ela que a janela consulta,
   * e `clientCode` continua livre para o operador corrigir sem fechar nada.
   */
  const [emConsulta, setEmConsulta] = useState(null);
  const { theme } = useContext(ThemeContext);
  const { currentClientValidated } = props;
  const [invitedOperators, setInvitedOperators] = useState([]);
  const [showInviteUser, setShowInviteUser] = useState(false);
  const { textConfigs } = props;
  const [transferModal, setTransferModal] = useState(false);
  const [inviteModal, setInviteModal] = useState(false);
  const currentRoom = useSelector(selectCurrentRoom)
  const { roomStatusChanged } = useWebSocket();

  const handleOpenModal = () => {
    setTransferModal(true);
  };

  const handleCloseModal = () => {
    setTransferModal(false);
  };

  const finishRoom = async () => {
    const finishedRoomId = props.selectedRoom?.room_id;
    // Sempre registra quem encerrou o atendimento, mesmo quando há uma mensagem de
    // encerramento customizada configurada (que por si só não menciona o operador).
    const closingMessage = mensagemDeEncerramento(textConfigs, props.selectedRoom, user.name);
    // O TIPO depende do canal: no WhatsApp isto e registro INTERNO (5), que
    // fica no Historico e nao chega no cliente -- quem se despede la e a
    // mensagem configurada na instancia. No chat do site segue sendo mensagem
    // de sistema (4), que o cliente recebe como sempre recebeu.
    props.roomRef.current.sendMessage(closingMessage,
      user, props.selectedRoom.room_id, tipoDoEncerramento(props.selectedRoom),
      props.selectedRoom.whatsapp_instance_id || null);
    props.setSelectedRoom(null);
    props.getInProgressRooms(user.id)
    const ticketId = await props.finishRoom(props.selectedRoom.room_id, user.id, { ...props.currentClient, messages: [...currentRoom.messages] });
    // Remove a aba do chat finalizado do quickaccess (a aba do ticket criado é
    // adicionada automaticamente ao abrir o ticket).
    if (finishedRoomId && props.setViewedRooms) {
      props.setViewedRooms((props.viewedRooms || []).filter(r => String(r.room_id) !== String(finishedRoomId)));
    }
    setOpenConfirmModal(false);
    if (ticketId) {
      props.history.push(`/ticket/${ticketId}`);
    } else if (props.inProgressRooms.length === 1) {
      props.history.push("/painel-atendimentos");
    }
  };

  const inviteOperator = async (operatorId) => {
    try {
      if (invitedOperators.includes(operatorId)) {
        return;
      }

      setInvitedOperators([...invitedOperators, operatorId]);

      const operatorName = props.users.find(user => user.id === operatorId).name;
      toast.success(`Você convidou o operador ${operatorName} para o chat.`, {
        position: toast.POSITION.BOTTOM_CENTER,
        style: {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.success.contrastText,
        },
      });

      // props.UpdateInProgressRooms(room.room_id, user?.id, user?.id, invitedOperators);

    } catch (error) {

    }
  };

  useEffect(() => {
    let invitedUsers = Array.isArray(props.selectedRoom.invited_users)
      ? props.selectedRoom.invited_users
      : JSON.parse(props.selectedRoom.invited_users || "[]");
    invitedUsers = invitedUsers.map(Number);
    if (!invitedUsers.includes(user.id)) {
      invitedUsers.push(user.id);
    }
    setInvitedOperators(invitedUsers);
  }, [props.selectedRoom.invited_users, user.id]);

  // useEffect(() => {
  //   console.log(invitedOperators)
  //   if (invitedOperators.length > 0 && invitedOperators.length !== props.selectedRoom.invited_users.length) {
  //     const room = props.inProgressRooms.find(iRoom => iRoom.room_id === props.selectedRoom.room_id);
  //     if (room.user_id !== user.id) {
  //       props.UpdateInProgressRooms(room.room_id, room.user_id, user?.id, invitedOperators);
  //     } else {
  //       props.UpdateInProgressRooms(room.room_id, user?.id, user?.id, invitedOperators);
  //     }
  //   }
  //   // eslint-disable-next-line
  // }, [invitedOperators]);

  const UpdateInProgressRooms = (userId, actionType = "invite") => {
    const room = props.inProgressRooms.find(iRoom => iRoom.room_id === props.selectedRoom.room_id);
    // invited_users pode vir null/string/array — normaliza para array (evita crash
    // no .filter/.push abaixo quando é null).
    let invitedUsers = [];
    try {
      const parsed = Array.isArray(room.invited_users) ? room.invited_users : JSON.parse(room.invited_users || '[]');
      invitedUsers = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      invitedUsers = [];
    }
    let newOperator = props.users.find(user => user.id === userId);

    if (actionType === 'transfer') {
      invitedUsers = invitedUsers.filter(id => id !== props.user.id);
      props.UpdateInProgressRooms(room.room_id, userId, user?.id, invitedUsers, [props.currentClient]);
      const welcomeMessage = mensagemDeBoasVindas(textConfigs, props.selectedRoom, newOperator.name);
      props.roomRef.current.sendMessage(welcomeMessage,
        newOperator, room.room_id, 1, room.whatsapp_instance_id);
      roomStatusChanged(user);
    } else if (actionType === 'invite' && !invitedUsers.includes(userId)) {
      invitedUsers.push(userId);
      if (room.user_id !== user.id) {
        props.UpdateInProgressRooms(room.room_id, room.user_id, user?.id, invitedUsers, [props.currentClient]);
      } else {
        props.UpdateInProgressRooms(room.room_id, user?.id, user?.id, invitedUsers, [props.currentClient]);
      }
    }
    // props.UpdateInProgressRooms(room.room_id, userId, user?.id);
    if (props.inProgressRooms.length === 0) {
      props.setInProgressRooms([]);
      props.setRoomId();
      props.setSelectedRoom();
      props.setCurrentClient();
    } else {
      props.setCurrentClient();
      props.setRoomId();
      props.setSelectedRoom();
      props.setMessages([]);
      setInvitedOperators([user.id]);
    }
  };

  // Transfere o atendimento para um DEPARTAMENTO: o backend escolhe o operador
  // menos ocupado com chat disponível (empate = aleatório) ou, confirmado, joga na
  // fila. Retorna o resultado para o modal tratar a confirmação de fila.
  const departmentAction = async (serviceGroupId, queueConfirmed = false) => {
    const roomId = props.selectedRoom.room_id;
    try {
      const { data } = await http.post(`/rooms/${roomId}/transfer-department`, {
        service_group_id: serviceGroupId,
        queue_confirmed: queueConfirmed,
        exclude_user_id: user?.id, // não devolve pro próprio operador que está transferindo
      });
      if (data.result === 'assigned') {
        toast.success(`Transferido para ${data.user_name} (${data.service_group_name}).`);
        props.getInProgressRooms(user?.id);
        setTransferModal(false);
      } else if (data.result === 'queued') {
        toast.success(`Enviado para a fila (${data.service_group_name || 'departamento'}).`);
        props.getInProgressRooms(user?.id);
        setTransferModal(false);
      }
      return data;
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Erro ao transferir para o departamento.');
      return { result: 'error' };
    }
  };

  const loadClient = (currentClient, currentRoom) => {
    if (Object.keys(currentClient).length > 0) {
      return <ClientInformation client={currentClient} room={currentRoom} user={user} />
    } else if (Object.keys(currentClient).length === 0) {
      return <ClientInformation client={{name: currentRoom.name, email: currentRoom.name, telefone: currentRoom.name}} room={currentRoom} user={user} />
    }

    return <></>
  }

  useEffect(() => {
    if (currentClientValidated === false) {
      toast.error(`O código fornecido é inválido.`, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          '& .Toastify__close-button': {
            color: theme.palette.text.primary,
          }
        }
      });
    } else {
      props.setCompany(props.currentClient.company);
    }
    // eslint-disable-next-line
  }, [currentClientValidated]);

  return (
    /* `xs` é prop de item; em container o MUI avisa. Os três primeiros
       valores do `sx` são o que o `xs={12}` gerava -- ver
       `src/avisosDoConsole.test.js`. */
    <Grid container wrap='nowrap' sx={{
      flexBasis: '100%', flexGrow: 0, maxWidth: '100%',
      color: '#F3F4F5', display: 'flex', alignItems: 'flex-start',
      '.MuiGrid-root': {
        'bgcolor': theme.palette.background.chatHeader,
      },
      bgcolor: theme.palette.background.chatHeader,
      borderRadius: '10px',
    }}>
      {props.dimension <= 575
        ?
        <Grid className='toggle-button'>
          <IconButton onClick={() => props.setOpenChat(true)}>
            <ArrowBackIosRounded />
          </IconButton>
        </Grid>
        : null}

      <Grid item xs={12} className='client-info' sx={{
        '.MuiGrid-root': {
          'borderRadius': '10px',
        }
      }}>
        {/* {props.selectedRoom.client.name}
        {props.currentClient
          ? <p>{props.selectedRoom.client.clientCode} - {props.currentClient.nome}</p>
          : <p>{props.selectedRoom.client.clientCode}</p>} */}
        {props.currentClient ? loadClient(props.currentClient, props.selectedRoom) : null}
      </Grid>
      
      <ClickAwayListener onClickAway={() => setPopover(false)}>
        <Grid item xs onClick={() => setPopover(true)} sx={{ marginTop: '0.5rem', position: 'relative' }}>
          {props.selectedRoom ?
            <MoreVert className={popover ? 'popover-menu-button popover-menu-button-selected' : 'popover-menu-button'} />
            : null}
          <Grid className={popover ? 'my-popover popover-visible' : 'my-popover'} >
            <ul>
              <Box sx={{
                '&:hover': {
                  bgcolor: theme.palette.background.hover,
                  color: theme.palette.text.textField,
                },
              }}>
                <li className={`row ${props.chatClosed ? 'disabled' : 'menu-option'}`} onClick={() => setTransferModal(true)}>
                  <Box className='col-md-2'>
                    <SwapHorizSharp width={20} alt='' style={{ color: theme.palette.background.icon }} />
                  </Box>
                  <Box className='col-md-9' style={{ fontSize: '12px', alignSelf: 'center', fontWeight: 500 }}>
                    Transferir conversa
                  </Box>
                </li>
              </Box>
              <Box sx={{
                '&:hover': {
                  bgcolor: theme.palette.background.hover,
                  color: theme.palette.text.textField,
                },
              }}>
                <li className={`row ${props.chatClosed ? 'disabled' : 'menu-option'}`} onClick={() => setInviteModal(true)}>
                  <Box className='col-md-2'>
                    <AddCardSharp width={20} alt='' />
                  </Box>
                  <Box className='col-md-9' style={{
                    fontSize: '12px', alignSelf: 'center', fontWeight: 500,
                  }}
                  >
                    Convidar operador
                  </Box>
                </li>
              </Box>
              {props.currentClient.company_id !== null && (
                <Box sx={{
                  '&:hover': {
                    bgcolor: theme.palette.background.hover,
                    color: theme.palette.text.textField,
                  },
                }}>
                  <li className={`row ${props.chatClosed ? 'disabled' : 'menu-option'}`} >
                    <Box className='menu-option' onClick={() => {
                      props.updateClient(props.currentClient, props.currentClient.company.code);
                    }}>
                      <Box className='col-md-2' sx={{ backgroundColor: 'transparent' }}>
                        <CachedSharp width={20} alt='' />
                      </Box>
                      <Box className='col-md-9' style={{ fontSize: '12px', alignSelf: 'center', fontWeight: 500 }}>
                        Sincronizar
                      </Box>
                    </Box>
                  </li>
                </Box>
              )}
              <Box sx={{
                '&:hover': {
                  bgcolor: theme.palette.background.hover,
                  color: theme.palette.text.textField,
                },
              }}>
                <li className={`row ${props.chatClosed ? 'disabled' : 'menu-option'}`} onClick={() => setShowCodeInput(true)}>
                  <Box className='col-md-2'>
                    <VpnKeySharp width={20} alt='' />
                  </Box>
                  <Box className='col-md-9' style={{ fontSize: '12px', alignSelf: 'center', fontWeight: 500, width: showCodeInput ? "100%" : null }}>
                    {showCodeInput ? (
                      <ClickAwayListener onClickAway={() => setShowCodeInput(false)}>
                        <TextField
                          id="client-code-input"
                          label={props.currentClient.company_id === null ? "Colocar código" : "Associar cliente"}
                          variant="outlined"
                          value={clientCode || ''}
                          onChange={e => {
                            const value = e.target.value;
                            /*
                             * Numeros E a pontuacao do CNPJ. A caixa aceitava
                             * so digitos, entao `49.752.276/0002-04` colado
                             * nao entrava NADA -- e o pedido da Gisele e
                             * justamente associar por CNPJ. A pontuacao sai no
                             * `limparIdentificacao`, antes de ir ao servidor.
                             */
                            if (value === '' || /^[\d./-]+$/.test(value)) {
                              setClientCode(value);
                            }
                          }}
                          onKeyPress={e => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              if (clientCode && clientCode.trim() !== '') {
                                // CONSULTA. Quem associa e o botao da janela.
                                setEmConsulta(clientCode.trim());
                                setShowCodeInput(false);
                              }
                            }
                          }}
                          placeholder="Registro ou CNPJ do cliente"
                          autoFocus
                          size="small"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              backgroundColor: theme.palette.background.paper,
                              '& fieldset': {
                                borderColor: theme.palette.divider,
                                borderWidth: '1px',
                              },
                              '&:hover fieldset': {
                                borderColor: theme.palette.primary.main,
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: theme.palette.primary.main,
                                borderWidth: '2px',
                              },
                              // Remove as setas do input numérico
                              '& input[type=number]': {
                                MozAppearance: 'textfield',
                              },
                              '& input[type=number]::-webkit-outer-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                              '& input[type=number]::-webkit-inner-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0,
                              },
                            },
                            '& .MuiInputLabel-root': {
                              color: theme.palette.text.secondary,
                              fontSize: '0.875rem',
                              '&.Mui-focused': {
                                color: theme.palette.primary.main,
                              },
                            },
                            '& .MuiInputBase-input': {
                              color: theme.palette.text.primary,
                              fontSize: '0.875rem',
                              padding: '8px 12px',
                            },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  aria-label="Consultar cadastro"
                                  onClick={() => {
                                    if (clientCode && clientCode.trim() !== '') {
                                      setEmConsulta(clientCode.trim());
                                      setShowCodeInput(false);
                                    }
                                  }}
                                  disabled={!clientCode || clientCode.trim() === ''}
                                  sx={{
                                    color: theme.palette.primary.main,
                                    '&:hover': {
                                      backgroundColor: theme.palette.action.hover,
                                    },
                                    '&.Mui-disabled': {
                                      color: theme.palette.action.disabled,
                                    },
                                  }}
                                >
                                  <VpnKeySharp fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </ClickAwayListener>
                    ) : (
                      props.currentClient.company_id === null ? "Colocar código" : "Associar cliente"
                    )}
                  </Box>
                </li>
              </Box>
              {props.dimension <= 575
                ?
                <Box sx={{
                  '&:hover': {
                    bgcolor: theme.palette.background.hover,
                    color: theme.palette.text.textField,
                  },
                }}>
                  <li className={`row ${props.chatClosed ? 'disabled' : 'menu-option'}`} onClick={() => setOpenModal(true)}>
                    <Box className='col-md-2'>
                      <AddCardSharp width={20} alt='' />
                    </Box>
                    <Box className='col-md-9' style={{ fontSize: '12px', alignSelf: 'center', fontWeight: 500 }}>
                      Informações
                    </Box>
                  </li>
                </Box>
                : null
              }
              {
                props.user && props.user.profile_id
                  ?
                  props.selectedRoom
                    ?
                    <Box sx={{
                      '&:hover': {
                        bgcolor: theme.palette.background.hover,
                        color: theme.palette.text.textField,
                      },
                    }}>
                      <li className={`row ${props.chatClosed ? 'disabled' : 'menu-option'}`} onClick={() => setOpenConfirmModal(true)}>
                        <Box className='col-md-2'>
                          <ExitToAppSharp width={20} alt='' style={{ color: theme.palette.error.main }} />
                        </Box>
                        <Box className='col-md-9' style={{ fontSize: '12px', alignSelf: 'center', fontWeight: 500 }}>
                          Encerrar conversa
                        </Box>
                      </li>
                    </Box>
                    :
                    <Box sx={{
                      '&:hover': {
                        color: theme.palette.text.textField,
                      },
                    }}>
                      <li className={`row ${props.chatClosed ? 'disabled' : 'menu-option'}`}>
                        <Box className='col-md-2'>
                          <ExitToAppSharp width={20} alt='' style={{ color: theme.palette.error.main }} />
                        </Box>
                        <Box className='col-md-9' style={{ fontSize: '12px', alignSelf: 'center', fontWeight: 500 }}>
                          Encerrar conversa
                        </Box>
                      </li>
                    </Box>
                  : <></>
              }
            </ul>
          </Grid>
        </Grid>
      </ClickAwayListener>

      <Modal
        keepMounted
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Grid id="modal-description" style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '65%',
          backgroundColor: '#2A4D69',
          border: '2px solid #000',
          boxShadow: 24,
          margin: 0,
          padding: 8,
          borderRadius: 10,
        }}>
          {/*
            O `onClick` fica no IconButton, e nao no icone dentro dele.
            Com ele no filho, so a area do desenho fechava o modal -- a borda
            do botao nao respondia -- e o MUI avisava isso no console a cada
            render. O que o clique faz nao mudou.
          */}
          <IconButton onClick={() => setOpenModal(false)}>
            <Close style={{ right: '2%', position: 'fixed', top: '1%' }} />
          </IconButton>
          <RightSideBar openModal={openModal} setOpenModal={setOpenModal} />
        </Grid>
      </Modal>

      <Modal
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
      >
        <Grid sx={{
          position: 'absolute',
          top: '50vh',
          left: '50vw',
          transform: 'translate(-50%, -50%)',
          width: '25vw',
          border: '2px solid #000',
          boxShadow: 24,
          margin: 0,
          padding: 8,
          borderRadius: 2,
          textAlign: 'center',
        }}>
          <Typography>Tem certeza de que deseja encerrar o atendimento?</Typography>
          <Button onClick={() => setOpenConfirmModal(false)} sx={{ color: theme.palette.error.main }}>Não</Button>
          <Button onClick={finishRoom} sx={{ color: theme.palette.success.main }}>Sim</Button>
        </Grid>
      </Modal>

      {/*
        * A janela que mostra o cadastro antes de associar (ponto 15).
        *
        * `onAssociar` chama o MESMO `updateClient` de antes -- o caminho do
        * vinculo nao muda, so ganha uma confirmacao com os dados na frente.
        */}
      <ConsultaDeCadastro
        aberto={emConsulta !== null}
        identificacao={emConsulta || ''}
        onFechar={() => setEmConsulta(null)}
        onAssociar={(identificacao) => {
          props.updateClient(props.currentClient, identificacao);
          setEmConsulta(null);
          setClientCode('');
        }}
      />
      <UserTransferModal
        open={inviteModal}
        handleClose={() => setInviteModal(false)}
        users={props.users}
        title={"Convidar operador"}
        operatorAction={UpdateInProgressRooms}
        actionType={"invite"}
      >
      </UserTransferModal>

      <UserTransferModal
        open={transferModal}
        handleClose={() => setTransferModal(false)}
        users={props.users}
        title={"Transferir conversa"}
        operatorAction={UpdateInProgressRooms}
        actionType={"transfer"}
        showDepartments={true}
        departmentAction={departmentAction}
      >
      </UserTransferModal>
    </Grid>
  )
}

const mapStateToProps = state => {
  const { rooms, clients, user, serviceGroups } = state;
  const { inProgressRooms, viewedRooms } = rooms;
  const { currentClient, currentClientValidated } = clients;
  const { users } = user;
  const { textConfigs, timeConfigs } = serviceGroups;
  return { inProgressRooms, viewedRooms, currentClient, users, currentClientValidated, textConfigs, timeConfigs };
};

const mapDispatchToProps = dispatch => ({
  getInProgressRooms: operatorId => dispatch(getInProgressRooms(operatorId)),
  finishRoom: (roomId, userId, ticketData) => dispatch(finishRoom(roomId, userId, ticketData)),
  UpdateInProgressRooms: (roomId, userId, userIdActual, invitedUsers, ticketData) => dispatch(UpdateInProgressRooms(roomId, userId, userIdActual, invitedUsers, ticketData)),
  setCurrentClient: currentClient => dispatch(setCurrentClient(currentClient)),
  updateClient: (client, clientCode) => dispatch(updateClient(client, clientCode)),
  setCompany: company => dispatch(setCompany(company)),
  setViewedRooms: rooms => dispatch(setViewedRooms(rooms)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChatOptions));